import styled from 'styled-components'
import { Flex } from 'vvs-uikit'

export const StyledTeamSelectContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  flex: 1;
  background: ${({ theme }) => theme.colors.lightAqua};
  padding: 16px 15px 15px 15px;
`
